module.exports = __webpack_public_path__ + "static/img/Pumb.c046b9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Pumb.png
// module id = l4+g
// module chunks = 0